var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("UsersAssignerDialog", {
        attrs: { viewModel: _vm.usersAssignerDialog },
        on: { "assign-users": _vm.handleBulkAssignUsersCommand },
      }),
      _vm._v(" "),
      _c("PortfolioOrDecisionNavigation", {
        attrs: { workspaceId: _vm.workspaceId, projectId: _vm.tchProjectId },
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "container",
          staticStyle: { "margin-top": "80px", "padding-top": "40px" },
        },
        [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-lg-6" }, [
              _c(
                "h1",
                {
                  staticStyle: {
                    "font-size": "2em",
                    "font-weight": "300",
                    color: "#33475b",
                    margin: "0",
                  },
                },
                [_vm._v("Assign " + _vm._s(_vm.rm?.AlternativesLabel))]
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("hr", {
            staticStyle: { "border-color": "#bbb", margin: "20px 0 60px" },
          }),
          _vm._v(" "),
          _vm.rm
            ? _c(
                "div",
                {
                  staticClass: "d-flex align-items-center gap-3 flex-wrap mb-3",
                },
                [
                  _c("div", { staticClass: "dropdown" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn",
                        class: _vm.filterByListId
                          ? "btn-info"
                          : "btn-outline-secondary",
                        attrs: { type: "button", "data-toggle": "dropdown" },
                      },
                      [
                        _c("i", {
                          staticClass: "fas fa-filter mr-1",
                          class: _vm.filterByListId
                            ? "text-warning"
                            : "text-muted",
                        }),
                        _vm._v(" "),
                        _c("span", [_vm._v("List")]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "dropdown-menu dropdown-menu-right dropdown-menu-scrollable",
                      },
                      [
                        _c(
                          "a",
                          {
                            staticClass: "dropdown-item",
                            class: { active: _vm.filterByListId === null },
                            on: {
                              click: function ($event) {
                                return _vm.setFilterByList(null)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                        Any / No filter\n                    "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "dropdown-divider" }),
                        _vm._v(" "),
                        _c("h6", { staticClass: "dropdown-header" }, [
                          _vm._v("Filter by list"),
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.rm.Lists, function (l) {
                          return _c(
                            "a",
                            {
                              key: l.Id,
                              staticClass: "dropdown-item",
                              class: { active: _vm.filterByListId === l.Id },
                              on: {
                                click: function ($event) {
                                  return _vm.setFilterByList(l.Id)
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(l.Name) +
                                  "\n                    "
                              ),
                            ]
                          )
                        }),
                      ],
                      2
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "dropdown ml-3" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn",
                        class:
                          _vm.filterByUserId !== null
                            ? "btn-info"
                            : "btn-outline-secondary",
                        attrs: { type: "button", "data-toggle": "dropdown" },
                      },
                      [
                        _c("i", {
                          staticClass: "fas fa-filter mr-1",
                          class:
                            _vm.filterByUserId !== null
                              ? "text-warning"
                              : "text-muted",
                        }),
                        _vm._v(" "),
                        _c("span", [_vm._v("Contributor")]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "dropdown-menu dropdown-menu-right dropdown-menu-scrollable",
                      },
                      [
                        _c(
                          "a",
                          {
                            staticClass: "dropdown-item",
                            class: { active: _vm.filterByUserId === null },
                            on: {
                              click: function ($event) {
                                return _vm.setFilterByUser(null)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                        Any / No filter\n                    "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "dropdown-divider" }),
                        _vm._v(" "),
                        _c("h6", { staticClass: "dropdown-header" }, [
                          _vm._v("Filter by user"),
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.users, function (user) {
                          return _c(
                            "a",
                            {
                              key: user.Id,
                              staticClass: "dropdown-item",
                              class: { active: _vm.filterByUserId === user.Id },
                              on: {
                                click: function ($event) {
                                  return _vm.setFilterByUser(user.Id)
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(user.Name) +
                                  "\n                    "
                              ),
                            ]
                          )
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "dropdown-divider" }),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass: "dropdown-item",
                            class: { active: _vm.filterByUserId === -1 },
                            on: {
                              click: function ($event) {
                                return _vm.setFilterByUser(-1)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                        Unassigned\n                    "
                            ),
                          ]
                        ),
                      ],
                      2
                    ),
                  ]),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.rm
            ? _c("div", [
                _c(
                  "div",
                  {
                    staticClass:
                      "toolbar mt-5 d-flex justify-content-between align-items-center",
                  },
                  [
                    _c("div", { staticClass: "search-container" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.searchPhrase,
                            expression: "searchPhrase",
                          },
                        ],
                        staticClass: "form-control form-control-sm",
                        attrs: { type: "text", placeholder: "Search..." },
                        domProps: { value: _vm.searchPhrase },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.searchPhrase = $event.target.value
                          },
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass:
                          "btn btn-sm btn-primary d-flex align-items-center",
                        attrs: { type: "button", disabled: _vm.noneSelected },
                        on: { click: _vm.showBulkUsersAssignerDialog },
                      },
                      [
                        _c("i", { staticClass: "fas fa-users-cog mr-2" }),
                        _vm._v(
                          " Assign (" +
                            _vm._s(_vm.selected.length) +
                            ")\n                "
                        ),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "table",
                  { staticClass: "table table-bordered table-hover" },
                  [
                    _c("thead", [
                      _c("tr", [
                        _c(
                          "th",
                          {
                            staticStyle: {
                              width: "40px",
                              "min-width": "40px !important",
                            },
                          },
                          [
                            _c("div", { staticClass: "btn-group" }, [
                              _vm.noneSelected
                                ? _c(
                                    "a",
                                    {
                                      staticClass: "pointer",
                                      on: { click: _vm.selectAll },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fa-regular fa-square",
                                      }),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.anySelected && !_vm.allSelected
                                ? _c(
                                    "a",
                                    {
                                      staticClass: "pointer",
                                      on: { click: _vm.unselectAll },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fa fa-minus-square",
                                      }),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.anySelected && _vm.allSelected
                                ? _c(
                                    "a",
                                    {
                                      staticClass: "pointer",
                                      on: { click: _vm.unselectAll },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fa-solid fa-square-check",
                                      }),
                                    ]
                                  )
                                : _vm._e(),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c("th", [_vm._v(_vm._s(_vm.rm.AlternativeLabel))]),
                        _vm._v(" "),
                        _c("th", [_vm._v("Contributor(s)")]),
                        _vm._v(" "),
                        _c("th", { staticStyle: { width: "120px" } }),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      _vm._l(_vm.alternativesView, function (p) {
                        return _c("tr", { key: p.Id }, [
                          _c("td", [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: p.IsUiSelected,
                                  expression: "p.IsUiSelected",
                                },
                              ],
                              attrs: { type: "checkbox" },
                              domProps: {
                                checked: Array.isArray(p.IsUiSelected)
                                  ? _vm._i(p.IsUiSelected, null) > -1
                                  : p.IsUiSelected,
                              },
                              on: {
                                change: function ($event) {
                                  var $$a = p.IsUiSelected,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        _vm.$set(
                                          p,
                                          "IsUiSelected",
                                          $$a.concat([$$v])
                                        )
                                    } else {
                                      $$i > -1 &&
                                        _vm.$set(
                                          p,
                                          "IsUiSelected",
                                          $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1))
                                        )
                                    }
                                  } else {
                                    _vm.$set(p, "IsUiSelected", $$c)
                                  }
                                },
                              },
                            }),
                          ]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(p.Name))]),
                          _vm._v(" "),
                          _c("td", [
                            _c(
                              "div",
                              { staticClass: "d-flex flex-wrap" },
                              _vm._l(p.UserIds, function (uId) {
                                return _c(
                                  "div",
                                  {
                                    key: uId,
                                    staticClass:
                                      "dropdown d-inline-block position-relative mr-2 mb-1",
                                  },
                                  [
                                    _c(
                                      "button",
                                      {
                                        staticClass:
                                          "btn btn-sm badge dropdown-toggle px-2 py-1 user-badge",
                                        class:
                                          _vm.filterByUserId === uId
                                            ? "badge-info"
                                            : "badge-secondary",
                                        attrs: {
                                          type: "button",
                                          "data-toggle": "dropdown",
                                          "aria-expanded": "false",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                                        " +
                                            _vm._s(_vm.getUserName(uId)) +
                                            "\n                                    "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "dropdown-menu" },
                                      [
                                        _c(
                                          "a",
                                          {
                                            staticClass: "dropdown-item",
                                            on: {
                                              click: function ($event) {
                                                return _vm.setFilterByUser(uId)
                                              },
                                            },
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "fas fa-filter mr-2",
                                            }),
                                            _vm._v(
                                              " Filter by user\n                                        "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "a",
                                          {
                                            staticClass:
                                              "dropdown-item text-danger",
                                            on: {
                                              click: function ($event) {
                                                return _vm.handleUnassignUserCommand(
                                                  p,
                                                  uId
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "fas fa-user-slash mr-2",
                                            }),
                                            _vm._v(
                                              " Unassign\n                                        "
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              }),
                              0
                            ),
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _c(
                              "button",
                              {
                                staticClass:
                                  "btn btn-sm btn-outline-primary d-flex align-items-center",
                                attrs: { type: "button" },
                                on: {
                                  click: function ($event) {
                                    return _vm.showUsersAssignerDialog(p)
                                  },
                                },
                              },
                              [
                                _c("i", {
                                  staticClass: "fas fa-user-plus mr-1",
                                }),
                                _vm._v(" Assign\n                            "),
                              ]
                            ),
                          ]),
                        ])
                      }),
                      0
                    ),
                  ]
                ),
              ])
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }